module.exports = __webpack_public_path__ + "static/media/co-mention-logo.3296ed92.svg";